import React from "react";
import get from "lodash/get";
import PropTypes from "prop-types";
import { StoryElement } from "@quintype/components";
import { AlsoRead } from "../elements/also-read";
import { Attachment } from "../elements/attachment";
import { References } from "../elements/references";
import { SlideShow } from "../elements/slide-show";
import { ListicleStoryImageElement } from "../../listicle-story";
import styles from "./styles.m.css";
import { DfpAd } from "../../../../../atoms/dfp-ad";
import { isPremium } from "../../../../../../../isomorphic/data/story";

const BlankStoryElement = () => <div className={styles["blank-story-element"]} />;

export function StoryCard(props) {
  const templates = {
    "also-read": AlsoRead,
    attachment: Attachment,
    references: References,
    composite: SlideShow
  };
  const imageAlignmentClass = get(props, ["card", "metadata", "attributes", "image-alignment", 0], null);

  let storyElements = props.card["story-elements"];

  let elements = [];

  if (props.story["story-template"] === "listicle") {
    let titleIdx = -1;
    let imageIdx = -1;
    let memberElements = [];
    titleIdx = storyElements.findIndex(element => element.type === "title");
    imageIdx = storyElements.findIndex(element => element.type === "image");
    if (imageIdx > -1) {
      memberElements.push(storyElements[imageIdx]);
    }

    if (titleIdx > -1) {
      memberElements.push(storyElements[titleIdx]);
    }

    for (let idx in storyElements) {
      if (parseInt(idx) !== titleIdx && parseInt(idx) !== imageIdx) {
        memberElements.push(storyElements[idx]);
      }
    }

    elements = memberElements.map(
      element =>
        element ? (
          element.type === "image" ? (
            <ListicleStoryImageElement element={element} />
          ) : (
            <StoryElement
              renderTemplates={templates}
              element={element}
              key={element.id}
              card={props.card}
              story={props.story}
              externalLink
            />
          )
        ) : null
    );

    if (imageIdx === -1 && props.card["card-type"] !== "introduction") {
      elements.unshift(<BlankStoryElement />);
    }
  } else {
    elements = storyElements.map((element, idx) => (
      <React.Fragment key={element.id}>
        <StoryElement
          externalLink
          renderTemplates={templates}
          element={element}
          card={props.card}
          story={props.story}
        />
        {props.story.cards.length === 1 &&
          idx % 2 === 0 &&
          !isPremium(props.story) && <DfpAd story={props.story} adtype="Rectangle" placement="story" />}
      </React.Fragment>
    ));
  }

  return <section className={`${styles["story-card"]} ${imageAlignmentClass}`}>{elements}</section>;
}

StoryCard.propTypes = {
  story: PropTypes.object,
  card: PropTypes.shape({
    "card-type": PropTypes.string,
    metadata: PropTypes.shape({
      attributes: PropTypes.shape({
        imagealignment: PropTypes.array
      })
    }),
    "story-elements": PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string
      })
    )
  }),
  firstVideoElement: PropTypes.string
};

export default StoryCard;
